const SendMoneyIcon = () => {
  return (
    <svg fill="none" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.3333 14.3333C10.3333 12.8606 11.5272 11.6667 12.9999 11.6667H18.9999C20.4727 11.6667 21.6666 12.8606 21.6666 14.3333V23C21.6666 24.4728 20.4727 25.6667 18.9999 25.6667H12.9999C11.5272 25.6667 10.3333 24.4728 10.3333 23V14.3333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M25.6666 13.6667V9C25.6666 7.52724 24.4727 6.33333 22.9999 6.33333H8.99992C7.52716 6.33333 6.33325 7.52724 6.33325 9V13.6667"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M17.6666 18.6667C17.6666 19.5871 16.9204 20.3333 15.9999 20.3333C15.0794 20.3333 14.3333 19.5871 14.3333 18.6667C14.3333 17.7462 15.0794 17 15.9999 17C16.9204 17 17.6666 17.7462 17.6666 18.6667Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </svg>
  )
}

export default SendMoneyIcon
